// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__DwtSp","loader__spinner":"Loader_loader__spinner__h6Akp","rotate":"Loader_rotate__NEbL0"};